export const REGULATORY_BASE = "/regulatory";

export function publicLibraryDocumentsPath(libraryId: string): string {
  return `${REGULATORY_BASE}/libraries/${libraryId}/documents`;
}

export function publicLibraryChatsPath(libraryId: string): string {
  return `${REGULATORY_BASE}/libraries/${libraryId}/chats`;
}

export function publicLibraryChatPath(libraryId: string, chatId: string): string {
  return `${publicLibraryChatsPath(libraryId)}/${chatId}`;
}

export function regulatoryLibrariesPath(): string {
  return `${REGULATORY_BASE}/libraries`;
}

export function regulatoryGlobalChatsPath(): string {
  return `${REGULATORY_BASE}/chat`;
}

export function regulatoryGlobalChatPath(chatId: string): string {
  return `${regulatoryGlobalChatsPath()}/${chatId}`;
}
